import type { ResourcesConfig } from 'aws-amplify';
import { AppDispatch, AppStore } from '../store/store';

export const globals: {
  awsConfig?: ResourcesConfig;
  dispatch?: AppDispatch;
  getState?: AppStore['getState'];
} = {}; // populated in App.tsx so apiAccess.js/axiosConfiguration.js can reach the store at runtime without importing it directly (which would create a require cycle back through apiAccess.js)
